import React, { useEffect, useState } from "react";
import OrderSummary from "./OrderSummary";
import DatePicker from "react-datepicker";
import SignupForm from "./SignupForm";
import { loginApiBody } from "./ApiBody";
import PasswordReset from "./PasswordReset";
import StepTab from "./StepTab";
import CurrencyConverter from "./CurrencyConverter";

const Login = ({ handleNext, tabClass, activeStepTab }) => {
  const [activeTab, setActiveTab] = useState("Login");

  let bookingData;
  if (typeof window !== "undefined" && window.sessionStorage) {
    bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
  }
  let userOrder;
  if (typeof window !== "undefined" && window.sessionStorage) {
    userOrder = JSON.parse(sessionStorage.getItem("userOrderSummary"));
  }

  const [resetPassword, setResetPassword] = useState(false);
  const [loginField, setLoginField] = useState({ email: "", password: "" });
  const [loginError, setLoginError] = useState({ email: "", password: "" });
  const [loggedInDetails, setLoggedInDetails] = useState({});
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [title, setTitle] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    title_text: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneCode: "",
    mobile: "",
    gender: "",
    dateOfBirth: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    fullAddress: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneCode: "",
    mobile: "",
    gender: "",
    dateOfBirth: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    fullAddress: "",
    password: "",
    confirmPassword: "",
  });

  // const updateFormField = (key, value) => {
  //   if (key === "title") {
  //     setFormData((p) => ({ ...p, title_text: value.split("-")[1] }));
  //   }
  //   if(key === "country"){
  //     const country = countries.find(item => item.id === parseInt(value));
  //     fetchStates(country.name);
  //   }
  //   setFormData((p) => ({ ...p, [key]: value }));
  //   setErrors((p) => ({ ...p, [key]: "" }));
  // };
  const updateFormField = (key, value) => {
    if (key === "title") {
      setFormData((p) => ({ ...p, title_text: value.split("-")[1] }));
    }
    if (key === "country") {
      const country = countries.find((item) => item.id === parseInt(value));
      fetchStates(country.name);
    }
    if (key === "state" || key === "city") {
      let finalValue = value;

      // If value contains letters, remove numbers
      if (/[A-Za-z]/.test(value)) {
        finalValue = value.replace(/\d/g, "");
      }

      setFormData((p) => ({
        ...p,
        [key]: finalValue,
      }));

      return;
    }
    if (key === "email") {
      const email = value.trim();
      const emailRegex = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

      setFormData((p) => ({
        ...p,
        "email":email,
      }));

      // 🔹 No value → no error
      if (!email) {
        setErrors((p) => ({
          ...p,
          email: "",
        }));
        return;
      }
      if (!emailRegex.test(email)) {
        setErrors((p) => ({
          ...p,
          email: "Invalid email format",
        }));
      } else {
        setErrors((p) => ({
          ...p,
          email: "",
        }));
      }

      return;
    }
    if (key === "fullAddress") {
      const address = value;

      // ✅ Always update form data correctly
      setFormData((p) => ({
        ...p,
        fullAddress: value,
      }));

      // ✅ Empty value → no error
      if (!address) {
        setErrors((p) => ({
          ...p,
          fullAddress: "",
        }));
        return;
      }

      // ❌ Prevent HTML tags
      if (/<[^>]*>/.test(address)) {
        setErrors((p) => ({
          ...p,
          fullAddress: "HTML tags are not allowed",
        }));
        return;
      }

      // ❌ Disallow other special characters (allow / and #)
      if (!/^[a-zA-Z0-9\s.,!?'"()\-\/#]+$/.test(address)) {
        setErrors((p) => ({
          ...p,
          fullAddress: "Address cannot contain special characters.",
        }));
        return;
      }

      // ✅ Clear error if valid
      setErrors((p) => ({
        ...p,
        fullAddress: "",
      }));

      return;
    }

    setFormData((p) => ({ ...p, [key]: value }));
    setErrors((p) => ({ ...p, [key]: "" }));
  };
  const updateField = (key, value) => {
    setLoginField((p) => ({ ...p, [key]: value }));
    setLoginError((p) => ({ ...p, [key]: "" }));
  };

  const handleLogin = async () => {
    if (!loginField.email && !loginField.password) {
      setLoginError((p) => ({
        ...p,
        email: "Please Enter Email",
        password: "Please Enter Password",
      }));
      return;
    } else if (!loginField.email) {
      setLoginError((p) => ({ ...p, email: "Please Enter Email" }));
      return;
    } else if (!loginField.password) {
      setLoginError((p) => ({ ...p, password: "Please Enter Password" }));
      return;
    }
    setLoading(true);
    const apiUrl = `/dial-api/encalm/login`;

    const apiBody = loginApiBody(loginField, bookingData, userOrder);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiBody),
      });
      const result = await response.json();
      setLoading(false);
      if (result.status === "ok") {
        setLoggedInDetails(result.data);
        setLoginError({ email: "", password: "" });
      } else {
        // Unified error message to prevent username enumeration
        setLoginError((p) => ({
          ...p,
          email: "Invalid credentials. Please check your email and password.",
          password: "",
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
      setLoading(false);
      setLoginError((p) => ({
        ...p,
        email: "An error occurred. Please try again later.",
        password: "",
      }));
    }
  };

  const fetchCountry = async () => {
    const apiUrl = "/dial-api/encalm/details";

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      if (result.status === "ok") {
        setTitle(result?.data?.salutation);
        setCountries(result?.data?.country);
      }
    } catch (error) {
      console.error("Error calling API:", error);
      setLoading(false);
      throw error;
    }
  };

  const fetchStates = async (countryId) => {
    const apiUrl = `/dial-api/encalm/states?country=${countryId}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      if (result.status === "ok") {
        setStates(result?.states);
      }
    } catch (error) {
      console.error("Error calling API:", error);
      setLoading(false);
      throw error;
    }
  };

  const handleForgotPassword = () => {};

  useEffect(() => {
    // fetchStates("India");
    fetchCountry();
  }, []);

  return (
    <div>
      <CurrencyConverter totalAmount={userOrder?.totalAmount} />
      <div className="px-[7vw] py-[2vw]">
        <StepTab tabClass={tabClass} activeTab={activeStepTab} />
        <div className="flex flex-col xl:flex-row gap-[3vw] xl:gap-0 justify-between">
          <div className="w-[100%] xl:w-[65%]">
            <div className="flex gap-[2vw] font-redhatMedium">
              <button
                onClick={() => setActiveTab("Login")}
                className={`rounded-md text-[4vw] md:text-[2vw] xl:text-[1.2vw] px-[2vw] py-[0.5vw] ${
                  activeTab === "Login"
                    ? "bg-primary text-white"
                    : "bg-[#FDD7B4] text-black"
                }`}
              >
                I have an account
              </button>
              <button
                onClick={() => setActiveTab("Signup")}
                className={`rounded-md text-[4vw] md:text-[2vw] xl:text-[1.2vw]  px-[2vw] py-[0.5vw] ${
                  activeTab === "Signup"
                    ? "bg-primary text-white"
                    : "bg-[#FDD7B4] text-black"
                }`}
              >
                I am a new user
              </button>
            </div>

            {/* Login Form */}
            <div className="mt-[2vw]">
              {loggedInDetails && loggedInDetails?.user ? (
                // 🧍 Logged-in User Details Section
                <div className="flex flex-col gap-[1vw] border border-[#CACACA] rounded-lg p-[2vw] xl:p-[1vw] w-full xl:w-[60%] bg-[#fafafa]">
                  <h2 className="text-primary font-redhatMedium text-[4vw] md:text-[2vw] xl:text-[1.2vw] mb-[1vw]">
                    Logged In User Details
                  </h2>
                  {Object.entries({
                    Name: loggedInDetails.user.name,
                    Email: loggedInDetails.user.email,
                    Mobile: loggedInDetails.user.mobile,
                    City: loggedInDetails.user.city,
                    Country: loggedInDetails.user.country_id?.[1],
                    State: loggedInDetails.user.state_id?.[1],
                    Street: loggedInDetails.user.street,
                    ZIP: loggedInDetails.user.zip,
                    DOB: loggedInDetails.user.dob,
                    Gender: loggedInDetails.user.gender,
                  }).map(([label, value]) => (
                    <div
                      key={label}
                      className="flex justify-between border-b border-[#E0E0E0] py-[1vw]"
                    >
                      <p className="text-primary font-redhatMedium text-[3.5vw] md:text-[2vw] xl:text-[1vw]">
                        {label}
                      </p>
                      <p className="text-gray-600 font-redhatRegular text-[3.5vw] md:text-[2vw] xl:text-[1vw]">
                        {value || "-"}
                      </p>
                    </div>
                  ))}
                </div>
              ) : activeTab === "Login" ? (
                // 🔐 Login Form Section
                <div className="flex flex-col gap-[2vw]">
                  <div className="font-redhatRegular">
                    <label className="mb-[0.5vw] block font-redhatMedium text-[4vw] md:text-[2vw] xl:text-[1.2vw] text-primary">
                      Email Id
                    </label>
                    <input
                      value={loginField.email}
                      onChange={(e) => updateField("email", e.target.value)}
                      type="email"
                      className="w-[100%] xl:w-[55%] border border-[#CACACA] font-redhatRegular text-primary text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] px-[3vw] md:px-[2vw] xl:px-[1vw] py-[2vw] md:py-[1vw] xl:py-[0.5vw] rounded outline-none"
                    />
                    {loginError.email && (
                      <p className="text-red-500 text-[3.5vw] md:text-[1.5vw] xl:text-[0.9vw] font-redhatRegular">
                        {loginError.email}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="mb-[0.5vw] block font-redhatMedium text-[4vw] md:text-[2vw] xl:text-[1.2vw] text-primary">
                      Password
                    </label>
                    <input
                      value={loginField.password}
                      onChange={(e) => updateField("password", e.target.value)}
                      type="password"
                      className="w-[100%] xl:w-[55%] border border-[#CACACA] font-redhatRegular text-primary text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] px-[3vw] md:px-[2vw] xl:px-[1vw] py-[2vw] md:py-[1vw] xl:py-[0.5vw] rounded outline-none"
                    />
                    {loginError.password && (
                      <p className="text-red-500 text-[3.5vw] md:text-[1.5vw] xl:text-[0.9vw] font-redhatRegular">
                        {loginError.password}
                      </p>
                    )}
                  </div>
                  <div className="flex gap-[3vw] items-baseline">
                    <button
                      onClick={handleLogin}
                      className="rounded-md text-[4vw] md:text-[2vw] font-redhatMedium xl:text-[1.2vw] px-[2vw] py-[0.5vw] bg-primary text-white"
                    >
                      {loading ? "Please Wait..." : "Login"}
                    </button>
                    <p
                      onClick={() => setResetPassword(true)}
                      className="underline text-[4vw] md:text-[2vw] font-redhatRegular xl:text-[1.2vw] text-primary cursor-pointer"
                    >
                      Forgot Password
                    </p>
                  </div>
                  {resetPassword && (
                    <PasswordReset setShowPopup={setResetPassword} />
                  )}
                </div>
              ) : (
                // 📝 Signup Form
                <SignupForm
                  title={title}
                  countries={countries}
                  states={states}
                  formData={formData}
                  errors={errors}
                  updateFormField={updateFormField}
                />
              )}
            </div>
          </div>
          <div>
            <OrderSummary
              data={userOrder?.product}
              addonCart={userOrder?.addon}
              bookingData={bookingData}
              nextStep={`GuestDetails-${activeTab}`}
              loggedInDetails={loggedInDetails}
              handleNext={handleNext}
              formData={formData}
              setErrors={setErrors}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
